<template>
	<div>
		<el-form ref="formData" :model="formData" label-width="140" size="mini" class="form-block">
			<div class="form-block-content">
				<el-form-item v-for="(item,index) in formData.strengthen" :key="item.key" :label="(index+1)+'级强化材料'" :prop="'strengthen.'+index+'.value'"
				 class="form-block-item">
					<el-input-number type="number" v-model="item.value" placeholder="0"></el-input-number>
				</el-form-item>
			</div>
			<el-form-item>
				<el-button type="primary" @click="submitForm('formData')">提交</el-button>
				<el-button @click="resetForm('formData')">重置</el-button>
			</el-form-item>
		</el-form>
		<el-row :gutter="10" class="form-block">
			<el-col :span="6" v-for="(item,index) in formData.strengthen" :key="item.key">
				<div class="grid-content">
					<div class="strengthen-title">{{(index+1)+'级强化材料'}}({{item.group}}组,{{item.realVal}}个)</div>
					<div class="strengthen-stuffs" v-for="(sitem,sindex) in item.stuffs" :key="sindex+'_'">
						<div class="semi-finished">
							<div class="name">{{sitem.name}}</div>
							<div class="num">{{sitem.value}}</div>
						</div>
						<div class="basic-stuffs" v-if="sitem.child">
							<div class="basic-stuffs-item" v-for="(scitem,scindex) in sitem.child" :key="scindex+'__'">
								<div class="name">{{scitem.name}}</div>
								<div class="num">{{scitem.value}}</div>
							</div>
						</div>
					</div>
				</div>
			</el-col>
			<el-col :span="6">
				<div class="grid-content">
					<div class="strengthen-title">总计</div>
					<div class="sum-stuffs">
						<div class="strengthen-stuffs" v-for="(item,index) in sum" :key="index">
							<div class="semi-finished" style="font-size:16px;">
								<div class="name">{{item.name}}</div>
							</div>
							<div class="basic-stuffs">
								<div class="basic-stuffs-item" v-for="(sitem,sindex) in item" :key="sindex" v-if="sindex!='name'">
									<div class="name">{{sitem.name}}</div>
									<div class="num">{{sitem.num}}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</el-col>
		</el-row>
	</div>

</template>

<script>
	export default {
		data() {
			return {
				// 基本数据
				baseData:{
					level_1: {
						board: {
							name:'木板',
							num:2,
							value:0,
							child:{
								wood:{
									name:'木头',
									num:120,
									value:0,
								},
								twigs:{
									name:'小树枝',
									num:2,
									value:0,
								}
							}
						},	//木板
						brick: {
							name:'石砖',
							num:1,
							value:0,
							child:{
								stone:{
									name:'石头',
									num:120,
									value:0,
								},
								bone:{
									name:'骨头',
									num:2,
									value:0,
								},
								lime:{
									name:'石灰',
									num:2,
									value:0,
								}
							}
						}	//石砖
					},
					level_2:{
						board:{
							name:'木板',
							num:3,
							value:0,
							child:{
								wood:{
									name:'木头',
									num:120,
									value:0,
								},
								twigs:{
									name:'小树枝',
									num:2,
									value:0,
								}
							}
						},	//木板
						brick:{
							name:'石砖',
							num:1,
							value:0,
							child:{
								stone:{
									name:'石头',
									num:120,
									value:0,
								},
								bone:{
									name:'骨头',
									num:2,
									value:0,
								},
								lime:{
									name:'石灰',
									num:2,
									value:0,
								}
							}
						},	//石砖
						cement:{
							name:'水泥',
							num:1,
							value:0,
							child:{
								stone:{
									name:'石头',
									num:120,
									value:0,
								},
								paws:{
									name:'爪子',
									num:2,
									value:0,
								},
								sandstone:{
									name:'砂岩',
									num:2,
									value:0,
								}
							}
						}	//水泥
					},
					level_3:{
						board:{
							name:'木板',
							num:5,
							value:0,
							child:{
								wood:{
									name:'木头',
									num:120,
									value:0,
								},
								twigs:{
									name:'小树枝',
									num:2,
									value:0,
								}
							}
						},	//木板
						brick:{
							name:'石砖',
							num:1,
							value:0,
							child:{
								stone:{
									name:'石头',
									num:120,
									value:0,
								},
								bone:{
									name:'骨头',
									num:2,
									value:0,
								},
								lime:{
									name:'石灰',
									num:2,
									value:0,
								}
							}
						},	//石砖
						cement:{
							name:'水泥',
							num:1,
							value:0,
							child:{
								stone:{
									name:'石头',
									num:120,
									value:0,
								},
								paws:{
									name:'爪子',
									num:2,
									value:0,
								},
								sandstone:{
									name:'砂岩',
									num:2,
									value:0,
								}
							}
						},	//水泥
						oil:{
							name:'油脂',
							num:2,
							value:0,
						}	//油脂
					},
					level_4:{
						board:{
							name:'木板',
							num:5,
							value:0,
							child:{
								wood:{
									name:'木头',
									num:120,
									value:0,
								},
								twigs:{
									name:'小树枝',
									num:2,
									value:0,
								}
							}
						},	//木板
						brick:{
							name:'石砖',
							num:1,
							value:0,
							child:{
								stone:{
									name:'石头',
									num:120,
									value:0,
								},
								bone:{
									name:'骨头',
									num:2,
									value:0,
								},
								lime:{
									name:'石灰',
									num:2,
									value:0,
								}
							}
						},	//石砖
						cement:{
							name:'水泥',
							num:1,
							value:0,
							child:{
								stone:{
									name:'石头',
									num:120,
									value:0,
								},
								paws:{
									name:'爪子',
									num:2,
									value:0,
								},
								sandstone:{
									name:'砂岩',
									num:2,
									value:0,
								}
							}
						},	//水泥
						teeth:{
							name:'兽牙',
							num:2,
							value:0,
						}	//兽牙
					},
					level_5:{
						board:{
							name:'木板',
							num:5,
							value:0,
							child:{
								wood:{
									name:'木头',
									num:120,
									value:0,
								},
								twigs:{
									name:'小树枝',
									num:2,
									value:0,
								}
							}
						},	//木板
						brick:{
							name:'石砖',
							num:1,
							value:0,
							child:{
								stone:{
									name:'石头',
									num:120,
									value:0,
								},
								bone:{
									name:'骨头',
									num:2,
									value:0,
								},
								lime:{
									name:'石灰',
									num:2,
									value:0,
								}
							}
						},	//石砖
						cement:{
							name:'水泥',
							num:1,
							value:0,
							child:{
								stone:{
									name:'石头',
									num:120,
									value:0,
								},
								paws:{
									name:'爪子',
									num:2,
									value:0,
								},
								sandstone:{
									name:'砂岩',
									num:2,
									value:0,
								}
							}
						},	//水泥
						glass:{
							name:'玻璃',
							num:1,
							value:0,
						},	//玻璃
						granite:{
							name:'花岗岩',
							num:1,
							value:0,
						}	//花岗岩
					},
					level_6:{
						board:{
							name:'木板',
							num:5,
							value:0,
							child:{
								wood:{
									name:'木头',
									num:120,
									value:0,
								},
								twigs:{
									name:'小树枝',
									num:2,
									value:0,
								}
							}
						},	//木板
						brick:{
							name:'石砖',
							num:1,
							value:0,
							child:{
								stone:{
									name:'石头',
									num:120,
									value:0,
								},
								bone:{
									name:'骨头',
									num:2,
									value:0,
								},
								lime:{
									name:'石灰',
									num:2,
									value:0,
								}
							}
						},	//石砖
						cement:{
							name:'水泥',
							num:1,
							value:0,
							child:{
								stone:{
									name:'石头',
									num:120,
									value:0,
								},
								paws:{
									name:'爪子',
									num:2,
									value:0,
								},
								sandstone:{
									name:'砂岩',
									num:2,
									value:0,
								}
							}
						},	//水泥
						rebar:{
							name:'钢筋',
							num:1,
							value:0,
						},	//钢筋
						coatings:{
							name:'建筑涂料',
							num:1,
							value:0,
						}	//建筑涂料
					},
					level_7:{
						board:{
							name:'木板',
							num:5,
							value:0,
							child:{
								wood:{
									name:'木头',
									num:120,
									value:0,
								},
								twigs:{
									name:'小树枝',
									num:2,
									value:0,
								}
							}
						},	//木板
						brick:{
							name:'石砖',
							num:1,
							value:0,
							child:{
								stone:{
									name:'石头',
									num:120,
									value:0,
								},
								bone:{
									name:'骨头',
									num:2,
									value:0,
								},
								lime:{
									name:'石灰',
									num:2,
									value:0,
								}
							}
						},	//石砖
						cement:{
							name:'水泥',
							num:1,
							value:0,
							child:{
								stone:{
									name:'石头',
									num:120,
									value:0,
								},
								paws:{
									name:'爪子',
									num:2,
									value:0,
								},
								sandstone:{
									name:'砂岩',
									num:2,
									value:0,
								}
							}
						},	//水泥
						rebar:{
							name:'钢筋',
							num:1,
							value:0,
						},	//钢筋
						wjgj:{
							name:'无机硅胶',
							num:1,
							value:0,
						},	//无机硅胶
						coatings:{
							name:'建筑涂料',
							num:1,
							value:0,
						}	//建筑涂料
					}
				},
				
				sum:{
					semi_finished:{
						name:'半成品',
						board:{
							name:'木板',
							num:0
						},    //木板
						brick:{
							name:'石砖',
							num:0
						},    //石砖
						cement:{
							name:'水泥',
							num:0
						},   //水泥
						coatings:{
							name:'建筑涂料',
							num:0
						}, //建筑涂料
						wjgj:{
							name:'无机硅胶',
							num:0
						}     //无机硅胶
					},
					basic_stuffs:{
						name:'基本材料',
						wood:{
							name:'木头',
							num:0
						},     //木头
						twigs:{
							name:'小树枝',
							num:0
						},    //小树枝
						stone:{
							name:'石头',
							num:0
						},    //石头
						bone:{
							name:'骨头',
							num:0
						},     //骨头
						lime:{
							name:'石灰',
							num:0
						},     //石灰
						paws:{
							name:'爪子',
							num:0
						},     //爪子
						sandstone:{
							name:'砂岩',
							num:0
						},		//砂岩
						oil:{
							name:'油脂',
							num:0
						},      //油脂
						teeth:{
							name:'兽牙',
							num:0
						},    //兽牙
						glass:{
							name:'玻璃',
							num:0
						},    //玻璃
						granite:{
							name:'花岗岩',
							num:0
						},  //花岗岩
						rebar:{
							name:'钢筋',
							num:0
						},    //钢筋
					}
				},
				formData: {
					strengthen: [{
							name:'level_1',
							value: '',
							group:0,
							realVal:0,
							stuffs:{}
						},
						{
							name:'level_2',
							value: '',
							group:0,
							realVal:0,
							stuffs:{}
						},
						{
							name:'level_3',
							value: '',
							group:0,
							realVal:0,
							stuffs:{}
						},
						{
							name:'level_4',
							value: '',
							group:0,
							realVal:0,
							stuffs:{}
						},
						{
							name:'level_5',
							value: '',
							group:0,
							realVal:0,
							stuffs:{}
						},
						{
							name:'level_6',
							value: '',
							group:0,
							realVal:0,
							stuffs:{}
						},
						{
							name:'level_7',
							value: '',
							group:0,
							realVal:0,
							stuffs:{}
						}
					]
				}
			}
		},
		methods: {
			submitForm(formName) {
				for(let u in this.sum){
					for(let i in this.sum[u]){
						if(i != 'name'){
							this.sum[u][i].num = 0
						}
					}
				}
				this.formData.strengthen.forEach((item,index)=>{
					let value = Math.ceil(item.value/4)
					this.formData.strengthen[index].realVal = value*4
					this.formData.strengthen[index].group = value
					this.formData.strengthen[index].stuffs = this.calNums(this.baseData[item.name],value)
				}),setTimeout(()=>{this.calAllNums(this.formData.strengthen)},500)
			},
			calNums(param,val){
				for(let i in param){
					let num = param[i].num
					let sum = num * val
					param[i].value = sum
					if(param[i].child){
						param[i].child = this.calNums(param[i].child,sum)
					}
				}
				return param
			},
			calAllNums(params){
				for(let index in this.sum){
					let item = this.sum[index]
					for(let i in item){
						if(i != 'name'){
							params.forEach((pitem,pindex)=>{
								for(let j in pitem.stuffs){
									if(i == j) {
										item[i].num += pitem.stuffs[j].value
									}
								}
								
							})
						}
					}
					if(index == 'basic_stuffs'){
						//计算基本材料总数量
						for(let i in item){
							if(i != 'name'){
								console.log('i',i)
								params.forEach((pitem,pindex)=>{
									for(let j in pitem.stuffs){
										console.log('j',j)
										if(pitem.stuffs[j].child){
											for(let c in pitem.stuffs[j].child){
												console.log('c',c)
												if(i == c) {
													item[i].num += pitem.stuffs[j].child[i].value
												}
											}
										}
									}
								})
							}
						}
					}
				}			
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
				this.submitForm(formName)
			},

		}
	}
</script>

<style>
	.form-block {
		margin: 50px auto;
		padding: 0 50px;
	}

	.form-block-content,
	.form-block-item {
		display: flex;
		align-items: center;
	}

	.form-block-content {
		flex-wrap: wrap;
	}

	.form-block-item {
		margin-right: 20px;
	}

	.grid-content {
		border-radius: 4px;
		min-height: 36px;
		margin-bottom: 10px;
		background: #67C23A;
		color: #ffffff;
	}

	.strengthen-title {
		padding: 10px;
		text-align: center;
		font-size: 20px;
		border-bottom: 1px solid rgb(225, 243, 216);
	}

	.strengthen-stuffs {
		display: flex;
		align-items: center;
		font-size: 12px;
		border-bottom: 1px solid rgb(225, 243, 216);
	}
	.strengthen-stuffs .name,.strengthen-stuffs .num{
		white-space: nowrap;
	}
	.semi-finished {
		display: flex;
		align-items: center;
		justify-content: space-between;
		width: 50%;
		padding: 3px 10px;
	}

	.basic-stuffs {
		width: 50%;
		border-left: 1px solid rgb(225, 243, 216);
	}

	.basic-stuffs-item {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 3px 10px;
		border-bottom: 1px solid rgb(225, 243, 216);
	}

	.basic-stuffs-item:last-child {
		border: 0;
	}
</style>
